import { SemgrepExample } from "@types";

export const EDITOR_EXAMPLES: SemgrepExample[] = [
  {
    description:
      "See how Semgrep’s semantic matching differs from grep’s text matching",
    title: "Semgrep vs. grep",
    snippet_id: "semgrep-examples:exec",
    language: "javascript",
  },
  {
    description:
      "Find where we forgot to check the return code of a subprocess call",
    title: "Unchecked subprocess return code",
    snippet_id: "semgrep-examples:unchecked-returns",
    language: "python",
  },
  {
    description:
      "Warn about likely copy-paste errors where both sides of an == operator have the same code",
    title: "Using Semgrep's metavariables",
    snippet_id: "semgrep-examples:equality",
    language: "python",
  },
  {
    description: "Find various ways credentials could be hard-coded",
    title: "Constant propagation",
    snippet_id: "semgrep-examples:boto3",
    language: "python",
  },
  {
    description:
      "Write a private rule for misuse of your project’s business logic",
    title: "Custom rules",
    snippet_id: "semgrep-examples:verify",
    language: "java",
  },
  {
    description: "Automatically patch identified issues",
    title: "Autofix",
    snippet_id: "semgrep-examples:autofix",
    language: "python",
  },
  {
    description: "Gather an inventory of all routes in your web application",
    title: "API routes",
    snippet_id: "semgrep-examples:routes",
    language: "java",
  },
  {
    description:
      "Find hard-coded IP addresses by filtering Semgrep's matches with a regular expression",
    title: "Combining Semgrep and regex",
    snippet_id: "semgrep-examples:regex",
    language: "regex",
  },
  {
    description: "Scan AWS IAM policies for misconfiguration",
    title: "Bugs in config files",
    snippet_id: "semgrep-examples:json",
    language: "json",
  },
];
